import angular from 'angular'
import allEleInvRedTemplate from './view/allEleInvRed.html'

class redInkConfirmFormInvoiceCtrl {
    constructor($scope, httpRequest, globalFn, logger, $state, $stateParams, composeService, $uibModal) {
        $scope.ukeyList = JSON.parse(localStorage.getItem('user_info')).tax4UkeyList

        $scope.invoiceList = []
        $scope.startNum = 1
        $scope.totalNum = $stateParams.total
        $scope.type = $stateParams.type
        $scope.selectBillIndex = 0
        $scope.confirmIds = $stateParams.confirmIds.split(',')
        $scope.ukeyId = $stateParams.ukeyId?$stateParams.ukeyId:$scope.ukeyList[0].ukeyId
        $scope.needAuto = false
        /**
         * @description: 获取字典
         */
        const getDict = () => {
            $scope.dictData = {}
            const types = ['red_confirm_work_status', 'red_confirm_status', 'red_confirm_open_status', 'red_confirm_red_reason', 'vat_usage_code', 'excise_usage_code', 'entry_status']
            httpRequest.get_dictByTypeArr(types).then((res) => {
                $scope.dictData = res.data.value
            })
        }
        /**
         * @description: 自动还原是否开启
         * @param {*} httpRequest
         */
        const errdisableApprovalIsOpen = () => {
            httpRequest.post_getSysParam({ params: ['is_auto_invoice_restore'] }).then((res) => {
                $scope.errdisableApprovalIsOpen = res.data.value[0].paramValue == 0 ? false : true
            })
        }
        /**
         * @description: 批量校验发票能否还原
         * @param {*} needAuto 是否弹窗
         */
        const isAllRestore = () => {
            httpRequest.post_checkIsAlloRestore($scope.confirmIds).then((res) => {
                let redData = res.data.value
                $scope.needAuto = redData.needAuto
                $scope.allowReatoreList = redData.allowReatoreList
                $scope.notAllowReatoreList = redData.notAllowReatoreList
                //允许还原
                angular.forEach($scope.allowReatoreList, (item, index) => {
                    item.restoreBlueInvoice = true
                })
                //不允许还原
                angular.forEach($scope.notAllowReatoreList, (item, index) => {
                    item.restoreBlueInvoice = false
                })
                $scope.reatoreInvList = [...$scope.allowReatoreList, ...$scope.notAllowReatoreList]
            })
        }
        /**
         * @description: 获取红字确认单详细信息
         */
        const redConfirmInfo = () => {
            httpRequest.post_getListRedConfirmBody({ confirmIds: $stateParams.confirmIds.split(',') }).then((res) => {
                $scope.invoiceList = res.data.value
                angular.forEach($scope.invoiceList, (item, index) => {
                    const newUkeyListArr = $scope.ukeyList.filter((item) => item.ukeyId == $scope.ukeyId)
                    item.openPeople = newUkeyListArr[0].defaultDrawer // 开票人
                    item.custEmail = item.custEmail?item.custEmail:item.sendMail
                    let blueElectricInvoiceNum = item.blueElectricInvoiceNum?item.blueElectricInvoiceNum:''
                    let blueInvoiceCode = item.blueInvoiceCode?item.blueInvoiceCode:''
                    let blueInvoiceNumber = item.blueInvoiceNumber?item.blueInvoiceNumber:''
                    let confirmNo = item.confirmNo?item.confirmNo:''
                    if (item.blueInvType == '61' || item.blueInvType == '62') {
                        if (item.remark) {
                            item.remark = '被红冲蓝字全电发票号码：' + blueElectricInvoiceNum + '，红字发票信息确认单编号：' + confirmNo + '。' + item.remark
                        } else {
                            item.remark = '被红冲蓝字全电发票号码：' + blueElectricInvoiceNum + '，红字发票信息确认单编号：' + confirmNo + '。'
                        }
                    } else {
                        if (item.remark) {
                            item.remark =
                                '被红冲蓝字发票代码：' + blueInvoiceCode + '被红冲蓝字发票号码 ：' + blueInvoiceNumber + '，红字发票信息确认单编号：' + confirmNo + '。' + item.remark
                        } else {
                            item.remark = '被红冲蓝字发票代码：' + blueInvoiceCode + '被红冲蓝字发票号码 ：' + blueInvoiceNumber + '，红字发票信息确认单编号：' + confirmNo + '。'
                        }
                    }
                })
                $scope.invoiceListShow = $scope.invoiceList[$scope.selectBillIndex]
                totalCalculation($scope.invoiceListShow.ovatTax4RedConfirmDetails)
            })
        }

        $scope.init = composeService(redConfirmInfo, isAllRestore, errdisableApprovalIsOpen, getDict)
        $scope.init()
        $scope.prevInv = function () {
            if ($scope.selectBillIndex === 0) return
            $scope.selectBillIndex--
            $scope.startNum--
            $scope.invoiceListShow = $scope.invoiceList[$scope.selectBillIndex]
            totalCalculation($scope.invoiceListShow.ovatTax4RedConfirmDetails)
        }
        $scope.nextInv = function () {
            if ($scope.selectBillIndex === $scope.totalNum - 1) return
            $scope.selectBillIndex++
            $scope.startNum++
            $scope.invoiceListShow = $scope.invoiceList[$scope.selectBillIndex]
            totalCalculation($scope.invoiceListShow.ovatTax4RedConfirmDetails)
        }
        // 更新 合计 金额 税额
        function totalCalculation(billList) {
            $scope.totalAmount = 0
            $scope.totalTaxAmount = 0
            $scope.totalAdValoremTotal = 0
            angular.forEach(billList, (item, index) => {
                $scope.totalAmount = globalFn.Add($scope.totalAmount, item.amount)
                $scope.totalTaxAmount = globalFn.Add($scope.totalTaxAmount, item.taxAmount)
                $scope.totalAdValoremTotal = globalFn.Add($scope.totalAmount, $scope.totalTaxAmount)
            })
            $scope.chineseAmtTotal = globalFn.digitUppercase($scope.totalAdValoremTotal)
        }
        // 选择开票点
        $scope.changerUkeyId = function changerUkeyId() {
            console.log($scope.invoiceListShow.ukeyId)
            const newUkeyListArr = $scope.ukeyList.filter((item) => item.ukeyId === $scope.invoiceListShow.ukeyId)
            $scope.invoiceListShow.openPeople = newUkeyListArr[0].defaultDrawer // 开票人
            angular.forEach($scope.invoiceList, (item, index) => {
                item.ukeyId = $scope.invoiceListShow.ukeyId
                item.openPeople = $scope.invoiceListShow.openPeople
            })
        }
        // 返回
        $scope.returnList = function returnList() {
            $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
        }
        // 开票 / 批量开票
        $scope.openBillBtn = function openBillBtn() {
            $scope.restoreAuthority = $scope.errdisableApprovalIsOpen && $scope.needAuto
            // console.log($scope.restoreAuthority)
            // 是否符合自动还原
            const isOpenAutoRestore = {
                true: {
                    openMapper() {
                        $scope.openRedConfirm()
                    },
                },
                false: {
                    openMapper() {
                        if ($scope.type == '2') {
                            angular.forEach($scope.invoiceList, (item, index) => {
                                item.restoreBlueInvoice = false
                            })
                            $scope.batchOpenInv($scope.invoiceList)
                        } else {
                            $scope.singleOpenInv(false)
                        }
                    },
                },
            }
            isOpenAutoRestore[$scope.restoreAuthority].openMapper()
        }
        /**
         * @description: 批量开票
         * @param {*} invoiceList
         */
        $scope.batchOpenInv = (invoiceList) => {
            let data = []
            angular.forEach(invoiceList, (item, index) => {
                data.push({
                    confirmId: item.confirmId,
                    ukeyId: item.ukeyId,
                    custEmail: item.custEmail,
                    uuid: item.uuid,
                    restoreBlueInvoice: item.restoreBlueInvoice,
                })
            })
            httpRequest.post_batchOpenRedInvoice(data).then((res) => {
                const value = res.data.value
                logger.logSuccess(`开票成功${value.successNum}条，失败${value.failNum}条。`)
                $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
            })
        }
        /**
         * @description: 单张开票
         * @param {*} restoreBlueInvoice  是否自动还原
         */
        $scope.singleOpenInv = (restoreBlueInvoice) => {
            let param = {
                confirmId: $scope.invoiceList[0].confirmId,
                ukeyId: $scope.invoiceList[0].ukeyId,
                custEmail: $scope.invoiceList[0].custEmail,
                uuid: $scope.invoiceList[0].uuid,
                restoreBlueInvoice,
            }
            httpRequest.post_openRedInvoice(param).then((res) => {
                logger.logSuccess(`开票成功!`)
                $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
            })
        }
        $scope.openRedConfirm = function () {
            $scope.reatoreInvList.forEach((item)=>{
                item.custEmail = $scope.invoiceListShow.custEmail
            })
            $uibModal
                .open({
                    template: allEleInvRedTemplate,
                    controller: 'allEleInvRedTemplateCtr',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-so-hg mod-modal-batchred',
                    resolve: {
                        items1() {
                            return $scope.reatoreInvList
                        },
                    },
                })
                .result.then((modaldata) => {
                    let autoRestore  = modaldata.autoRestore=='0'?false:true
                    if ($scope.type == '2') {
                        //允许还原数据是否自动还原
                        angular.forEach($scope.allowReatoreList, (item, index) => {
                            item.restoreBlueInvoice = autoRestore
                        })
                        const InvList = [...$scope.allowReatoreList, ...$scope.notAllowReatoreList]
                        $scope.batchOpenInv(InvList)
                    } else {
                        $scope.singleOpenInv(autoRestore)
                    }
                })
        }
    }
}

redInkConfirmFormInvoiceCtrl.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', '$state', '$stateParams', 'composeService', '$uibModal']
export default redInkConfirmFormInvoiceCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/invoicingCtrl.js